import React from 'react';
import { drapcodeIcon } from '../custom/icon-library';

const SubmitButton = ({ icon, title, text, children }) => {
  return (
    <button type="submit" className="btn btn-theme-submit btn-md" title={title}>
      <i className={`wb ${drapcodeIcon(icon)}`}></i>
      &nbsp;{text}&nbsp;
      {children}
    </button>
  );
};

export default SubmitButton;
